/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Label_AddressInputs */

const en_contact_label_address = /** @type {(inputs: Contact_Label_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address`)
};

const pl_contact_label_address = /** @type {(inputs: Contact_Label_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adres`)
};

/**
* | output |
* | --- |
* | "Address" |
*
* @param {Contact_Label_AddressInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_label_address = /** @type {((inputs?: Contact_Label_AddressInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Label_AddressInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_label_address(inputs)
	return en_contact_label_address(inputs)
});